import { formatDateForSearchApi, validateAbsoluteDate, parseDate, } from '../../../../../api/search/date/date-format.js';
import { serializeRelativeDate, isRelativeDate, isRelativeDateFormat, validateRelativeDate, } from '../../../../../api/search/date/relative-date.js';
/**
 * Creates a `DateRangeRequest`.
 *
 * @param config - The options with which to create a `DateRangeRequest`.
 * @returns A new `DateRangeRequest`.
 */
export function buildDateRange(config) {
    const start = buildDate(config.start, config);
    const end = buildDate(config.end, config);
    const endInclusive = config.endInclusive ?? false;
    const state = config.state ?? 'idle';
    return {
        start,
        end,
        endInclusive,
        state,
    };
}
function buildDate(rawDate, options) {
    const { dateFormat } = options;
    if (isRelativeDate(rawDate)) {
        validateRelativeDate(rawDate);
        return serializeRelativeDate(rawDate);
    }
    if (typeof rawDate === 'string' && isRelativeDateFormat(rawDate)) {
        validateRelativeDate(rawDate);
        return rawDate;
    }
    validateAbsoluteDate(rawDate, dateFormat);
    return formatDateForSearchApi(parseDate(rawDate, dateFormat));
}
